module.exports = __webpack_public_path__ + "img/33rd_anniversary_0714-B.1174c668.jpg";